import { NgClass } from '@angular/common';
import { Component, input } from '@angular/core';
import { FormButtonConfigI } from './interfaces/form-button-config.interface';

@Component({
    selector: 'app-form-button',
    imports: [NgClass],
    templateUrl: './form-button.component.html',
    styleUrl: './form-button.component.scss'
})
export class FormButtonComponent {
  config = input.required<FormButtonConfigI>();
}
